import { TextField, TextFieldProps } from '@soluto-private/mx-asurion-ui-react';
import classNames from 'classnames';
import { forwardRef } from 'react';
import styles from './text-input.module.scss';

export const TextInput = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ inputClassName, ...props }: TextFieldProps, ref) => (
    <TextField
      ref={ref}
      affixLeft={null}
      affixRight={null}
      autoCapitalize="none"
      inputClassName={classNames(styles.text_field, inputClassName)}
      {...props}
    />
  ),
);

TextInput.displayName = 'TextInput';
